/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateOpenApiKeyRequest { 
    accountId?: string | null;
    ipWhiteList?: Array<string> | null;
    verificationCode: string;
}

